import React, { useState } from "react";
import { AddNewModal, AddToTrackingModal } from "../Add";

const Header = ({ onAdd, extraFilters }) => {
  const [showTracking, setShowTracking] = useState(false);
  const [showNewProgram, setShowNewProgram] = useState(false);

  const handleSetupTracking = () => {
    setShowTracking(true);
  };

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Programs Setup</h1>
          <button
            className="add-new-btn"
            variant="none"
            onClick={handleSetupTracking}
          >
            <img
              className="me-2 add-user-icon"
              src="/assets/images/setup-TT-icon.svg"
              alt="Set Up Time Tracking"
            />
            Set Up Time Tracking
          </button>
        </div>
      </div>
      <AddToTrackingModal
        show={showTracking}
        handleClose={() => setShowTracking(false)}
        handleOpenAddNew={() => {
          setShowTracking(false);
          setShowNewProgram(true);
        }}
      />
      <AddNewModal
        show={showNewProgram}
        handleClose={() => setShowNewProgram(false)}
      />
    </>
  );
};

export default Header;
